interface CarbonStatusBadgeProps {
  status: string;
  type?: "project" | "compensation" | "area";
}

export default function CarbonStatusBadge({ status, type = "project" }: CarbonStatusBadgeProps) {
  const normalized = status.toLowerCase().trim();

  const projectConfig: Record<string, { bg: string; text: string; border: string; icon: string }> = {
    "planejado": { bg: "bg-secondary-50", text: "text-secondary-700", border: "border-secondary-200", icon: "ri-calendar-line" },
    "em levantamento": { bg: "bg-accent-50", text: "text-accent-700", border: "border-accent-200", icon: "ri-search-line" },
    "em estimativa": { bg: "bg-caution-50", text: "text-caution-700", border: "border-caution-200", icon: "ri-calculator-line" },
    "em monitoramento": { bg: "bg-primary-50", text: "text-primary-700", border: "border-primary-200", icon: "ri-pulse-line" },
    "em revisão": { bg: "bg-warning-50", text: "text-warning-700", border: "border-warning-200", icon: "ri-refresh-line" },
    "concluído": { bg: "bg-primary-50", text: "text-primary-700", border: "border-primary-200", icon: "ri-check-line" },
    "arquivado": { bg: "bg-background-100", text: "text-foreground-500", border: "border-background-200", icon: "ri-archive-line" },
    "monitorada": { bg: "bg-primary-50", text: "text-primary-700", border: "border-primary-200", icon: "ri-pulse-line" },
    "planejada": { bg: "bg-secondary-50", text: "text-secondary-700", border: "border-secondary-200", icon: "ri-calendar-line" },
  };

  const compConfig: Record<string, { bg: string; text: string; border: string; icon: string }> = {
    "em plantio": { bg: "bg-accent-50", text: "text-accent-700", border: "border-accent-200", icon: "ri-seedling-line" },
    "em monitoramento": { bg: "bg-primary-50", text: "text-primary-700", border: "border-primary-200", icon: "ri-pulse-line" },
    "parcialmente cumprida": { bg: "bg-caution-50", text: "text-caution-700", border: "border-caution-200", icon: "ri-percent-line" },
    "cumprida": { bg: "bg-primary-50", text: "text-primary-700", border: "border-primary-200", icon: "ri-check-double-line" },
    "pendente": { bg: "bg-warning-50", text: "text-warning-700", border: "border-warning-200", icon: "ri-time-line" },
    "vencida": { bg: "bg-danger-50", text: "text-danger-700", border: "border-danger-200", icon: "ri-error-warning-line" },
  };

  const config = type === "compensation" ? compConfig : projectConfig;
  const c = config[normalized] || { bg: "bg-background-100", text: "text-foreground-500", border: "border-background-200", icon: "ri-question-line" };

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium border ${c.bg} ${c.text} ${c.border}`}>
      <i className={`${c.icon} w-3.5 h-3.5 flex items-center justify-center`} />
      <span className="whitespace-nowrap">{status}</span>
    </span>
  );
}